<template>
	<el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div class="search-view">
					<div>提交时间：</div>
					<el-date-picker v-model="time" type="daterange" align="right" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"
						value-format="yyyy-MM-dd HH:mm:ss" size="mini">
					</el-date-picker>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>考生昵称：</div>
					<el-input size="mini" placeholder="考生昵称" v-model="userName"></el-input>
				</div>
			</el-col>
			<el-col :span="5">
				<el-button size="mini" type="primary" @click="shaixuan">筛选</el-button>
				<el-button size="mini" type="text" @click="daochu">导出Excel</el-button>
			</el-col>
		</el-row>
		<el-table :data="tableDate" style="margin-top: 30px;">
			<el-table-column label="序号" prop="id">
			</el-table-column>
			<el-table-column label="考生昵称" prop="userName"></el-table-column>
			<el-table-column label="考生id" prop="userId"></el-table-column>
			<el-table-column label="得分" prop="score"></el-table-column>
			<el-table-column label="是否合格" prop="isQualified">
				<template slot-scope="scope">
					{{scope.row.isQualified ? '及格' :"不及格"}}
				</template>
			</el-table-column>
			<el-table-column label="提交时间" prop="createdAt"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="chakan(scope.row)">
						查看答案明细
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				time: [],
				userName: null,
				beginTime: '',
				endTime: '',
				tableDate: [],
				pageNum: 1,
				pageSize: 30,
				total: 0,
				pagelist: [30, 60, 100],
			}
		},
		methods: {
			shaixuan() {
				this.getInfo()
			},
			daochu() {
				if (this.time) {
					this.beginTime = this.time[0]
					this.endTime = this.time[1]
				} else {
					this.beginTime = ''
					this.endTime = ''
				}
				this.$http.post('/api/course/clrExaminee/exportExcel', {
					id: "",
					testParerId: this.$route.query.testParerId,
					userName: this.userName,
					userId: "",
					isQualified: "",
					beginTime: this.beginTime,
					endTime: this.endTime
				}, {
					responseType: 'blob'
				}).then(res => {
					this.$message({
						type: 'info',
						message: '正在导出表格'
					});
					const link = document.createElement('a');
					let blob = new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					});
					link.style.display = 'none';
					//设置连接
					link.href = URL.createObjectURL(blob);
					link.download = '考生列表';
					document.body.appendChild(link);
					//模拟点击事件
					link.click();
					window.URL.revokeObjectURL(link.href);
					link.remove();
				})
			},
			chakan(row) {
				console.log(row);
				this.$router.push({
					path: './seeDetail',
					query: {
						testPaperId: this.$route.query.testParerId,
						examineeId: row.id,
						userName: row.userName,
						userId: row.userId,
						isQualified: row.isQualified,
						score: row.score,
						createdAt: row.createdAt,
						title: this.$route.query.title
					}
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
			getInfo() {
				if (this.time) {
					this.beginTime = this.time[0]
					this.endTime = this.time[1]
				} else {
					this.beginTime = ''
					this.endTime = ''
				}
				this.$http.post('/api/course/clrExaminee/select', {
					entity: {
						testParerId: this.$route.query.testParerId,
						userName: this.userName,
						beginTime: this.beginTime,
						endTime: this.endTime
					},
					page: {
						pageNum: this.pageNum,
						pageSize: this.pageSize
					}
				}).then(res => {
					console.log(res.data.data.list);
					this.tableDate = res.data.data.list
					this.total = res.data.data.total
				})
			}
		},
		created() {
			this.getInfo()
			console.log(this.$route.query);
		}
	}
</script>

<style scoped="scoped">

</style>
